import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import { MouseEvent as ReactMouseEvent, useState } from "react";
import { pastelColors, tagColors } from "./tagColors";

interface SwatchProps {
	color: string;
	onSelect: (color: string) => void;
}

const Swatch = ({ color, onSelect }: SwatchProps) => {
	return (
		<div
			style={{
				width: "25px",
				height: "25px",
				display: "inline-block",
				margin: "2px",
				borderRadius: "4px",
				cursor: "pointer",
				backgroundColor: color,
			}}
			onClick={() => onSelect(color)}
		/>
	);
};

interface Props {
	onChange: Function;
	color: string;
	elementId?: number;
	disabled?: boolean;
	label?: string;
	colorMode?: "normal" | "light";
	colors?: string[];
}

const ColorPicker = ({
	onChange,
	color,
	elementId,
	disabled = false,
	label,
	colorMode = "normal",
	colors,
}: Props) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const handleClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};
	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	return (
		<div>
			<Button
				aria-describedby={id}
				variant="outlined"
				onClick={handleClick}
				style={{
					backgroundColor: color,
					width: "24px",
					height: "24px",
					minWidth: "24px",
					padding: 0,
					marginBottom: "6px",
				}}
				disabled={disabled}
			/>
			{label && <span style={{ marginLeft: "8px" }}>{label}</span>}

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						padding: "10px",
						maxWidth: "165px",
					}}
				>
					{(colors ?? (colorMode === "light" ? pastelColors : tagColors)).map(
						(color) => (
							<Swatch
								key={color}
								color={color}
								onSelect={(color: string) => {
									onChange(elementId, color);
									handleClose();
								}}
							/>
						),
					)}
				</div>
			</Popover>
		</div>
	);
};

export default ColorPicker;
